const routes = {
  Home: {
    to: '/apps/Admin/_home',
    as: '/admin',
    pathname: '/admin',
  },
  AppointmentList: {
    to: '/apps/Admin/appointments',
    as: '/admin/appointments',
    pathname: '/admin/appointments',
  },
  AppointmentDetails: {
    to: '/apps/Admin/appointments/[id]',
    as: '/admin/appointments/:id',
    href: '/admin/appointments',
    pathname: '/admin/appointments/[id]',
  },
  MarketplaceEnrollmentDetails: {
    to: '/apps/Admin/partner_programs/[id]',
    as: '/admin/partner_programs/:id',
    href: '/admin/partner_programs',
    pathname: '/admin/partner_programs/[id]',
  },
  AssessmentList: {
    to: '/apps/Admin/assessments',
    as: '/admin/assessments',
    pathname: '/admin/assessments',
  },
  AssessmentDetails: {
    to: '/apps/Admin/assessments/[id]',
    as: '/admin/assessments/:id',
    pathname: '/admin/assessments/[id]',
  },
  CaregiversList: {
    to: '/apps/Admin/caregivers',
    as: '/admin/caregivers',
  },
  CaregiverDetails: {
    to: '/apps/Admin/caregivers/[caregiver_id]',
    as: '/admin/caregivers/:id',
  },
  CensusIngestionCreate: {
    to: '/apps/Admin/census_ingestions/create',
    as: '/admin/census_ingestions/create',
    pathname: '/admin/census_ingestions/create',
  },
  CensusIngestionDetails: {
    to: '/apps/Admin/census_ingestions/[id]',
    as: '/admin/census_ingestions/:id',
    pathname: '/admin/census_ingestions/[id]',
  },
  CensusIngestionList: {
    to: '/apps/Admin/census_ingestions',
    as: '/admin/census_ingestions',
    pathname: '/admin/census_ingestions',
  },
  ChannelPartnerList: {
    to: '/apps/Admin/channel_partners',
    as: '/admin/channel_partners',
    pathname: '/admin/channel_partners',
  },
  ChannelPartnerCreate: {
    to: '/apps/Admin/create/channel_partners',
    as: '/admin/create/channel_partners',
  },
  ChannelPartnerDetails: {
    to: '/apps/Admin/channel_partners/[channel_partner_id]',
    as: '/admin/channel_partners/:id',
    pathname: '/admin/channel_partners/[channel_partner_id]',
  },
  CoveredLives: {
    to: '/apps/Admin/covered_lives',
    as: '/admin/covered_lives',
    pathname: '/admin/covered_lives',
  },
  CoveredLife: {
    to: '/apps/Admin/covered_lives/[id]',
    as: '/admin/covered_lives/:id',
    pathname: '/admin/covered_lives/[id]',
  },
  CustomerList: {
    to: '/apps/Admin/customers',
    as: '/admin/customers',
    pathname: '/admin/customers',
  },
  CustomerDetails: {
    to: '/apps/Admin/customers/[customer_id]',
    as: '/admin/customers/:id',
    pathname: '/admin/customers/[customer_id]',
  },
  CustomerCreate: {
    to: '/apps/Admin/create/customers',
    as: '/admin/create/customers',
  },
  CustomerCreationIngestionDetails: {
    pathname: '/admin/channel_partners/[channel_partner_id]/customer_ingestions/[ingestion_id]',
  },
  DeactivationsList: {
    to: '/apps/Admin/deactivations',
    as: '/admin/deactivations',
    pathname: '/admin/deactivations',
  },
  DeactivationDetail: {
    to: '/apps/Admin/deactivations/[id]',
    as: '/admin/deactivations/:id',
    pathname: '/admin/deactivations/[id]',
  },
  DemoAccountList: {
    to: '/apps/Admin/demo_accounts',
    as: '/admin/demo_accounts',
    pathname: '/admin/demo_accounts',
  },
  DemoAccountCreate: {
    to: '/apps/Admin/demo_accounts/create',
    as: '/admin/demo_accounts/create',
    pathname: '/admin/demo_accounts/create',
  },
  ConnectedBenefitList: {
    to: '/apps/Admin/connected_benefits',
    as: '/admin/connected_benefits',
    pathname: '/admin/connected_benefits',
  },
  CreateAdmin: {
    to: '/apps/Admin/create/admin',
    as: '/admin/create/admin',
  },
  CreateData: {
    to: '/apps/Admin/create/test_data',
    as: '/admin/create/test_data',
    pathname: '/admin/create/test_data',
  },
  UserList: {
    to: '/apps/Admin/users',
    as: '/admin/users',
    pathname: '/admin/users',
  },
  UserDetails: {
    to: '/apps/Admin/users/[id]',
    as: '/admin/users/:id',
    pathname: '/admin/users/[id]',
  },
  AdminCreate: {
    to: '/apps/Admin/create/admin',
    as: '/admin/create/admin',
    pathname: '/admin/create/admin',
  },
  MemberList: {
    to: '/apps/Admin/members',
    as: '/admin/members',
    pathname: '/admin/members',
  },
  MemberDetails: {
    to: '/apps/Admin/members/[id]',
    as: '/admin/members/:id',
    pathname: '/admin/members/[id]',
  },
  MemberCoveredLivesLookup: {
    to: '/apps/Admin/members/[id]/covered_lives_lookup',
    as: '/admin/members/:id/covered_lives_lookup',
    pathname: '/admin/members/[id]/covered_lives_lookup',
  },
  MemberRecommendedTherapists: {
    to: '/apps/Admin/members/[id]/recommended_therapists',
    as: '/admin/members/:id/recommended_therapists',
    pathname: '/admin/members/[id]/recommended_therapists',
  },
  MemberTracker: {
    to: '/apps/Admin/members/[id]/tracker',
    as: '/admin/members/:id/tracker',
  },
  ProviderCreate: {
    to: '/apps/Admin/create/providers',
    as: '/admin/create/providers',
  },
  ProviderList: {
    to: '/apps/Admin/providers',
    as: '/admin/providers',
    pathname: '/admin/providers',
  },
  ProviderDetail: {
    to: '/apps/Admin/providers/[id]',
    as: '/admin/providers/:id',
    pathname: '/admin/providers/[id]',
  },
  CustomerDataIntegrations: {
    to: '/apps/Admin/customer_data_integrations',
    as: '/admin/customer_data_integrations',
    pathname: '/admin/customer_data_integrations',
  },
  PersonifyIntegrations: {
    to: '/apps/Admin/customer_data_integrations?api=true',
    as: '/admin/customer_data_integrations?api=true',
  },
  ReportingPartners: {
    to: '/apps/Admin/customer_data_integrations?partners=true',
    as: '/admin/customer_data_integrations?partners=true',
  },
  ReportingPartnerFormPage: {
    to: '/apps/Admin/reporting_partners/[id]',
    as: '/admin/reporting_partners/:id',
  },
  CreateSFTPIntegration: {
    to: '/apps/Admin/create/sftp_integrations',
    as: '/admin/create/sftp_integrations',
  },
  SFTPIntegrationFormPage: {
    to: '/apps/Admin/sftp_integrations/[id]',
    as: '/admin/sftp_integrations/:id',
  },
  PersonifyIntegrationFormPage: {
    to: '/apps/Admin/personify_integrations/[id]',
    as: '/admin/personify_integrations/:id',
  },
  CreatePersonifyIntegration: {
    to: '/apps/Admin/create/personify_integrations',
    as: '/admin/create/personify_integrations',
  },
  Tickets: {
    to: '/apps/Admin/tickets',
    as: '/admin/tickets',
  },
  AdminTwoFactorAuthentication: {
    to: '/apps/Admin/settings/two_factor_authentication',
    as: '/admin/settings/two_factor_authentication',
    pathname: '/admin/settings/two_factor_authentication',
  },
  'AdminTwoFactorAuthentication--SMS': {
    to: '/apps/Admin/settings/two_factor_authentication/sms',
    as: '/admin/settings/two_factor_authentication/sms',
  },
  'AdminTwoFactorAuthentication--App': {
    to: '/apps/Admin/settings/two_factor_authentication/app',
    as: '/admin/settings/two_factor_authentication/app',
  },
  SSOClients: {
    to: '/apps/Admin/sso_clients',
    as: '/admin/sso_clients',
    pathname: '/admin/sso_clients',
  },
  SSOClientDetail: {
    to: '/apps/Admin/sso_clients/[id]',
    as: '/admin/sso_clients/:id',
    pathname: '/admin/sso_clients/[id]',
  },
  PaperTrail: {
    to: '/apps/Admin/paper_trail',
    as: '/admin/paper_trail',
  },
  TrialCreate: {
    to: '/apps/Admin/create/trials',
    as: '/admin/create/trials',
  },
  TrialList: {
    to: '/apps/Admin/trials',
    as: '/admin/trials',
    pathname: '/admin/trials',
  },
  TrialDetails: {
    to: '/apps/Admin/trials/[id]',
    as: '/admin/trials/:id',
    pathname: '/admin/trials/[id]',
  },
  CoveredLifeDetails: {
    to: '/apps/Admin/covered_lives/:id',
    as: '/admin/covered_lives/:id',
    href: '/admin/covered_lives',
    pathname: '/admin/covered_lives/[id]',
  },
  CohortDetails: {
    pathname: '/admin/customers/[customer_id]/cohort/[cohort_id]',
  },
  CoveredLivesMover: {
    pathname: '/admin/customers/[customer_id]/cohort/[cohort_id]/covered_lives_mover',
  },
  CustomerRateCards: {
    to: '/apps/Admin/customer_rate_cards',
    as: '/admin/customer_rate_cards',
    pathname: '/admin/customer_rate_cards',
  },
  CustomerRateCardDetails: {
    to: '/apps/Admin/customer_rate_cards/:id',
    as: '/admin/customer_rate_cards/:id',
    pathname: '/admin/customer_rate_cards/[id]',
  },
  ProviderRateCardsList: {
    to: '/apps/Admin/provider_rate_cards',
    as: '/admin/provider_rate_cards',
    pathname: '/admin/provider_rate_cards',
  },
  ProviderRateCardDetail: {
    to: '/apps/Admin/provider_rate_cards/[id]/versions/[versionId]',
    as: '/admin/provider_rate_cards/:id/versions/:versionId',
    pathname: '/admin/provider_rate_cards/[id]/versions/[versionId]',
  },
  ProviderRateCardDetailEdit: {
    to: 'apps/Admin/provider_rate_cards/[id]/edit',
    as: '/admin/provider_rate_cards/:id/edit',
    href: '/admin/provider_rate_cards',
    pathname: '/admin/provider_rate_cards/[id]/edit',
  },
  RevenueCycle: {
    to: '/apps/Admin/revenue_cycle',
    as: '/admin/revenue_cycle',
    pathname: '/admin/revenue_cycle',
  },
  BCBSPrefixesList: {
    to: '/apps/Admin/bcbs_prefixes',
    as: '/admin/bcbs_prefixes',
    pathname: '/admin/bcbs_prefixes',
  },
  BulkMemberChargesList: {
    to: '/apps/Admin/bulk_member_charges',
    as: '/admin/bulk_member_charges',
    pathname: '/admin/bulk_member_charges',
  },
  BulkMemberChargesDetails: {
    to: '/apps/Admin/bulk_member_charges/[id]',
    as: '/admin/bulk_member_charges/:id',
    pathname: '/admin/bulk_member_charges/[id]',
  },
  BulkMemberChargesCreate: {
    to: '/apps/Admin/create/bulk_member_charges',
    as: '/admin/create/bulk_member_charges',
    pathname: '/admin/create/bulk_member_charges',
  },
  MaintenanceTasksList: {
    to: '/apps/Admin/maintenance_tasks',
    as: '/admin/maintenance_tasks',
    pathname: '/admin/maintenance_tasks',
  },
  Regions: {
    to: '/apps/Admin/regions',
    as: '/admin/regions',
    pathname: '/admin/regions',
  },
  RegionDetails: {
    to: '/apps/Admin/regions/[id]',
    as: '/admin/regions/:id',
    pathname: '/admin/regions/[id]',
  },
  InsurancePayerEnablementsList: {
    to: '/apps/Admin/insurance_payer_enablements',
    as: '/admin/insurance_payer_enablements',
  },
  InsurancePayerEnablementCreate: {
    to: '/apps/Admin/create/insurance_payer_enablements',
    as: '/admin/create/insurance_payer_enablements',
  },
  InsurancePayerEnablementDetails: {
    to: '/apps/Admin/insurance_payer_enablements/[id]',
    as: '/admin/insurance_payer_enablements/:id',
    pathname: '/admin/insurance_payer_enablements/[id]',
  },
  SubCustomerDetails: {
    pathname: '/admin/channel_partners/[channel_partner_id]/sub_customer/[customer_id]',
  },
  SubCustomerCohortDetails: {
    pathname: '/admin/channel_partners/[channel_partner_id]/sub_customer/[customer_id]/cohort/[cohort_id]',
  },
  PatientPracticeList: {
    to: '/apps/Admin/patient_practices',
    as: '/admin/patient_practices',
    pathname: '/admin/patient_practices',
  },
  PatientPracticeDetails: {
    to: '/apps/Admin/patient_practices/[id]',
    as: '/admin/patient_practices/:id',
    pathname: '/admin/patient_practices/[id]',
  },
};

export default routes;
